import React, { createContext, useContext, useState } from 'react';
import dayjs from 'dayjs';

const FilterContext = createContext();

export function FilterProvider({ children }) {
  const [plantIds, setPlantIds] = useState([1]);
  const [dateFrom, setDateFrom] = useState(dayjs().subtract(1, 'day'));
  const [dateTo, setDateTo] = useState(dayjs().subtract(1, 'day'));
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [granularity, setGranularity] = useState('15min');

  const resetFilters = () => {
    setPlantIds([1]);
    setDateFrom(dayjs().subtract(1, 'day'));
    setDateTo(dayjs().subtract(1, 'day'));
    setStartTime(null);
    setEndTime(null);
    setGranularity('15min');
  };

  return (
    <FilterContext.Provider value={{
      plantIds, setPlantIds, dateFrom, setDateFrom, dateTo, setDateTo,
      startTime, setStartTime, endTime, setEndTime,
      granularity, setGranularity, resetFilters,
      // Convenience: build params for API calls
      apiParams: (isMarket = false) => {
        const p = { granularity };
        if (plantIds.length === 1) p.plant_id = plantIds[0];
        else if (plantIds.length > 1) p.plant_ids = plantIds.join(',');
        if (dateFrom) p.date_from = dateFrom.format('YYYY-MM-DD');
        if (dateTo) {
          const yesterday = dayjs().subtract(1, 'day');
          const effectiveDateTo = (!isMarket && (granularity === 'monthly' || granularity === 'yearly') && dateTo.isAfter(yesterday, 'day'))
            ? yesterday
            : dateTo;
          p.date_to = effectiveDateTo.format('YYYY-MM-DD');
        }
        if (startTime) p.start_time = startTime.format('HH:mm');
        if (endTime) p.end_time = endTime.format('HH:mm');
        return p;
      },
    }}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilters = () => useContext(FilterContext);
